/** ClubChamp Hub-Motive — Hero-Assets folgen; bis dahin interim Hub-Card-Bild. */

export const CLUBCHAMP_HUB_HERO = {
  src: "/media/hub/clubmeisterschaft-960.webp",
  srcWide: "/media/hub/clubmeisterschaft-960.webp",
  /** Zielpfade, sobald die finalen Hero-Bilder geliefert sind */
  needed: [
    "/media/hub/clubchamp/hero.webp",
    "/media/hub/clubchamp/hero-1440.webp",
  ],
};
